// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__1PvOV","btn":"card_btn__T5ton","headingcont":"card_headingcont__3D55I","hidd":"card_hidd__1ffTB","vis":"card_vis__1LLBv"};